// DESCRIPTION: Step 3 — weekly work hours. Renders the shared AvailabilityEditor
// in its wizard variant; supports multiple time blocks per day.

import { __ } from '@wordpress/i18n';
import WizardShell from '../components/WizardShell';
import AvailabilityEditor from '../../components/AvailabilityEditor';

/**
 * @since PBOOKING_SINCE
 *
 * @param {Object}   props
 * @param {Object}   props.value       Canonical availability: { mon: [{start,end},...], ... }
 * @param {Function} props.onChange    (nextAvailability) => void
 * @param {Function} props.onBack
 * @param {Function} props.onSkip      Skip this step.
 * @param {Function} props.onSkipSetup Skip the entire setup.
 * @param {Function} props.onContinue
 * @param {number}   props.progress
 * @param {boolean}  props.isLoading
 *
 * @return {JSX.Element}
 */
export default function WorkHoursStep( {
	value,
	onChange,
	onBack,
	onSkip,
	onSkipSetup,
	onContinue,
	progress,
	isLoading,
} ) {
	return (
		<WizardShell
			stepKey="hours"
			progress={ progress }
			onBack={ onBack }
			onSkip={ onSkip }
			onSkipSetup={ onSkipSetup }
			onContinue={ onContinue }
			isLoading={ isLoading }
		>
			<div className="nemtly-wizard-step">
				<h2 className="nemtly-wizard-headline">
					{ __( 'Work Hours', 'nemtly-booking' ) }
				</h2>
				<p className="nemtly-wizard-lede">
					{ __(
						'When can people book your services? Add multiple time windows per day if you take breaks. You can refine this per event later.',
						'nemtly-booking'
					) }
				</p>

				<AvailabilityEditor
					variant="wizard"
					availability={ value }
					onChange={ onChange }
				/>
			</div>
		</WizardShell>
	);
}
